import React, { useCallback, useState, useEffect, useRef } from 'react';
import styled, { css } from '../../styled';
import { Chevron } from '../icons/outline/Chevron';
import Text from '../text';
import * as Icons from '../icons';
const Container = styled.div `
  width: inherit;
  position: relative;
`;
const TitleContainer = styled.div `
  display: flex;
  background-color: ${({ theme }) => theme.colors.INK_800};
  padding: 0.75rem 0 0.75rem 0.75rem;
  align-items: center;
  justify-content: space-between;
  transition-duration: 0.3s;
  ${({ enableShowMore }) => enableShowMore &&
    css `
      cursor: pointer;
    `};
  ${({ enableShowMore }) => enableShowMore &&
    css `
      &:hover {
        background-color: ${({ theme }) => theme.colors.INK_700};
      }
    `}
`;
const TextContainer = styled.div `
  position: relative;
  width: calc(100% - 6.5rem);
  padding: 0 0.75rem;
  display: flex;
  flex: 1;
  flex-flow: column;
  ${({ enableShowMore }) => enableShowMore && 'padding-right: 0'}
`;
const IconWrapper = styled.div `
  width: ${({ theme }) => theme.icons.size.MEDIUM};
  margin: 0 0.5rem;
  line-height: 0;

  > svg {
    transition: transform 0.3s ease-in-out;
  }
`;
const DropDownContainer = styled.div `
  position: relative;
  width: calc(100% - 0.5rem);
  border-radius: 4px;
  position: absolute;
  background: ${({ theme }) => theme.colors.SNOW_100};
  z-index: 1;
  box-shadow: 0 0 1rem 0 rgba(54, 62, 81, 0.1),
    0 0.0625rem 0.25rem 0 rgba(54, 62, 81, 0.2);
  transition: all 0.25s ease-in-out;
  max-height: ${({ open, dropDownMaxHeight }) => open ? dropDownMaxHeight : '0'};
  overflow: auto;
  margin: 0 0.25rem;
`;
const MenuIconContainer = styled.div `
  border-radius: 8px;
  overflow: hidden;
  text-align: center;
  position: relative;
  cursor: unset;
  background-color: #fff;
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 2.25rem;
    height: 2.25rem;
  }
`;
const MenuUrlIcon = styled.div `
  width: 3.5rem;
  height: 3.5rem;
  box-sizing: border-box;
  border-radius: 4px;
  background: url(${({ image }) => image}) no-repeat;
  background-size: cover;
  background-position: center;
`;
const ImageContainer = ({ imageType = 'URI', image, }) => {
    if (imageType === 'URI')
        return React.createElement(MenuUrlIcon, { image: image });
    const [name, category = 'Outline'] = image.split('/').reverse();
    const MenuIcon = Icons[category] && Icons[category][name];
    return (MenuIcon && (React.createElement(MenuIconContainer, null,
        React.createElement(MenuIcon, { size: "LARGE", color: "INK_400" }))));
};
const PanelProfile = ({ lang = 'zh-hant', image, titleText = '', descriptionText = '', enableShowMore = false, dropDownMaxHeight = '22.75rem', dropDownRender, imageType = 'URI', onResize = () => { }, }) => {
    const [showMoreOpen, setShowMoreOpen] = useState(false);
    const wrapperRef = useRef(null);
    const handleClickOutside = (event) => {
        if (wrapperRef.current &&
            !wrapperRef.current.contains(event.target)) {
            setShowMoreOpen(false);
        }
    };
    useEffect(() => {
        if (enableShowMore) {
            document.addEventListener('mouseup', handleClickOutside);
            return () => {
                document.removeEventListener('mouseup', handleClickOutside);
            };
        }
        return () => { };
    }, [enableShowMore]);
    const handleResize = useCallback(() => {
        setShowMoreOpen(false);
    }, []);
    useEffect(() => {
        onResize(handleResize);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement(Container, { ref: wrapperRef },
        React.createElement(TitleContainer, { "data-e2e-id": "sidebar_merchant_menu", enableShowMore: enableShowMore, onClick: () => setShowMoreOpen(!showMoreOpen) },
            image && React.createElement(ImageContainer, { imageType: imageType, image: image }),
            React.createElement(TextContainer, { enableShowMore: enableShowMore },
                React.createElement(Text, { lang: lang, color: "SNOW_100", fontType: "Body" }, titleText),
                React.createElement(Text, { lang: lang, color: "INK_400", fontType: "Micro" }, descriptionText)),
            enableShowMore && (React.createElement(IconWrapper, null,
                React.createElement(Chevron, { size: "MEDIUM", color: "INK_500", position: showMoreOpen ? 'TOP' : 'BOTTOM' })))),
        enableShowMore && (React.createElement(DropDownContainer, { open: showMoreOpen && enableShowMore, dropDownMaxHeight: dropDownMaxHeight }, dropDownRender))));
};
export default PanelProfile;
//# sourceMappingURL=index.js.map